<template>
  <div class="function-btns-container">
    <div
      class="undo-wrapper"
      @mousedown="() => undoStartHandler('mousedown')"
      @mouseup="() => undoEndHandler('mouseup')"
      @touchstart="() => undoStartHandler('touchstart')"
      @touchend="() => undoEndHandler('touchEnd')"
    >
      <img src="@/assets/svg/btns/undo.svg" class="undo" />
      <span class="undo-label">{{ $t('Undo') }}</span>
    </div>
    <Chip :chipValue="chips[0]" :disabled="false">
      <img src="@/assets/svg/chips/blue.svg" />
    </Chip>
    <Chip :chipValue="chips[1]" :disabled="false">
      <img src="@/assets/svg/chips/orange.svg" />
    </Chip>
    <Chip :chipValue="chips[2]" :disabled="false">
      <img src="@/assets/svg/chips/black.svg" />
    </Chip>
    <Chip :chipValue="chips[3]" :disabled="false">
      <img src="@/assets/svg/chips/purple.svg" />
    </Chip>
    <CustomChip />
    <div class="bet-btn-wrapper" @click.stop="submitBetHandler" :class="{ disabled: submitting || nobets }">
      <img class="bet-btn-bg" src="@/assets/images/bet_bg.png" />
      <img src="@/assets/svg/btns/bet_rotate.svg" class="bet-btn-rotate" />
      <div class="bet-btn-text" :class="config.language">
        {{ $t('Bet') }}
      </div>
    </div>
  </div>
</template>
<script>
import Chip from '@/components/bet-panel/chip';
import CustomChip from '@/components/bet-panel/chip/custom-chip.vue';
import { mapGetters, mapActions } from 'vuex';
import { isMobile } from 'mobile-device-detect';

export default {
  components: {
    Chip,
    CustomChip,
  },
  data: () => {
    return {
      submitting: false,
      interval: true,
    };
  },
  computed: {
    ...mapGetters({
      betData: 'bets/betData',
      activeChip: 'bets/activeChip',
      config: 'general/config',
    }),
    chips() {
      return this.config.betChips.map((chip) => Number(chip));
    },
    nobets() {
      const { banker, draw, player } = this.betData;
      return banker + player + draw <= 0;
    },
  },
  methods: {
    ...mapActions('bets', [
      'placeBet',
      'undoBet',
      'submitBet',
      'getMyBets',
      'resetBetData',
      'resetBetHistory',
    ]),
    ...mapActions('menu', ['updateMenu']),
    undoStartHandler(trigger) {
      if (isMobile && trigger === 'mousedown') return;
      if (!this.interval) {
        this.interval = setInterval(() => {
          this.resetBetHistory();
          this.resetBetData();
          clearInterval(this.interval);
        }, 500);
      }
    },
    undoEndHandler(trigger) {
      if (isMobile && trigger === 'mouseup') return;
      if (!this.interval) return;
      clearInterval(this.interval);
      this.interval = false;
      this.undoBet();
    },
    submitBetHandler() {
      this.submitting = true;
      this.submitBet()
        .then((res) => {
          this.getMyBets(res[0].fight_id);
        })
        .catch((err) => {
          this.updateMenu({
            isErrorPopupOpen: true,
            errorHeading: 'Bet not successful',
            errorMsg: `${err.data.message} E${err.data.code}`,
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.function-btns-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 100px;
  min-height: 80px;
  width: 100%;
  align-items: center;
  min-width: 468px;
  box-sizing: border-box;
  color: #fff;
  position: relative;

  & > div {
    @include user-select-none();
    margin: 0 2px;
  }

  // The custom chip is now wrapped by the shared field, so the field takes the
  // flex sizing `.chip-wrapper` applied when the Chip was the direct child.
  & > .custom-chip-field {
    flex: 2;
    max-width: 88px;
  }

  .undo-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    align-items: center;
    position: relative;

    .undo {
      cursor: pointer;
      width: 46px;
      height: 46px;
    }

    .undo-label {
      position: absolute;
      transform: translateY(32px);
      text-transform: uppercase;
      font-size: 12px;
      white-space: nowrap;
    }

    &:active {
      opacity: 0.5;
    }
  }

  .bet-btn-wrapper {
    display: flex;
    flex: 1;
    position: relative;
    cursor: pointer;
    border-radius: 50%;
    min-width: 80px;
    min-height: 80px;
    max-width: 108px;

    img,
    svg {
      width: 100%;
      height: 100%;

      &.bet-btn-bg {
        z-index: 1;
      }
      &.bet-btn-rotate {
        position: absolute;
        width: 72%;
        height: 72%;
        top: 12%;
        left: 12%;
        opacity: 0.8;
        z-index: 2;
      }
    }
    .bet-btn-text {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-shadow: 0 0 2px #0c1522;
      font-size: 26px;
      z-index: 3;
      text-transform: uppercase;
      -webkit-tap-highlight-color: transparent;
      font-weight: 600;
      text-align: center;

      &.vn {
        font-size: 22px;
      }
    }
    &.disabled {
      opacity: 0.5;
      background-color: #000;
      pointer-events: none;
      cursor: not-allowed;
    }

    &:not(.disabled) {
      -webkit-animation: yellow 2s infinite;
      -moz-animation: yellow 2s infinite;
      -o-animation: yellow 2s infinite;
      animation: yellow 2s infinite;
      .bet-btn-rotate {
        animation: rotation 4s infinite linear;
      }
    }
  }
  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    25% {
      transform: rotate(-540deg);
    }
    75% {
      transform: rotate(-540deg);
    }
    100% {
      transform: rotate(-540deg);
    }
  }
}
</style>
